import { AutocompleteArrayInput, Button, useGetList, useNotify } from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { employeeRequests } from "api/employeeApi";
import { substituteLabel } from "./utils";

const POSITIONS_PER_PAGE = 100;

const SubstitutesInput = ({ substitutes }) => {
  const { data: positions = [], isPending } = useGetList(employeeRequests.getPositionsSelect(), {
    pagination: { page: 1, perPage: POSITIONS_PER_PAGE },
  });

  // The select skips inactive positions, so saved inactive substitutes are merged in to keep their chips.
  const choices = [
    ...positions.map(({ id, name }) => ({ id, name, isActive: true })),
    ...substitutes
      .filter(substitute => !positions.some(position => position.id === substitute.substitutePositionId))
      .map(({ substitutePositionId, nameBg, isActive }) => ({ id: substitutePositionId, name: nameBg, isActive })),
  ];

  return (
    <AutocompleteArrayInput
      source="substitutePositionIds"
      label="Длъжности"
      choices={choices}
      optionText={choice => substituteLabel(choice.name, choice.isActive)}
      getOptionDisabled={choice => !choice.isActive}
      isPending={isPending}
      fullWidth
    />
  );
};

const EditApprovalSubstitutesDialog = ({ positionId, positionName, substitutes, onSaved }) => {
  const notify = useNotify();

  const handleConfirm = async ({ substitutePositionIds }) => {
    // A missing or null list is rejected by the backend; only [] clears it.
    await dataProvider.customRequest(
      employeeRequests.updatePositionApprovalSubstitutes(positionId),
      { substitutePositionIds: substitutePositionIds ?? [] },
      "PUT",
    );
    notify("Заместниците при одобрение са обновени успешно", { type: "success" });
    onSaved();
  };

  return (
    <FormModal
      onConfirm={handleConfirm}
      titleContent={`Заместници при одобрение за „${positionName}“`}
      dialogSize="md"
      defaultValues={{ substitutePositionIds: substitutes.map(substitute => substitute.substitutePositionId) }}
      triggerButton={
        <Button
          startIcon={<EditIcon />}
          label="Промени"
        />
      }
    >
      <SubstitutesInput substitutes={substitutes} />
    </FormModal>
  );
};

export default EditApprovalSubstitutesDialog;
